import axios from "axios";
import { DateRangePicker } from "react-date-range";
import { useState, useEffect } from "react";

const Countrygraph = () => {
  const baseAPI = process.env.REACT_APP_API_URL;

  const [countrydata, setCountrydata] = useState([]);
  const [dateRangeStage, setDateRangeStage] = useState("Select Date Range");
  const [isLeadStagePickerOpen, setIsLeadStagePickerOpen] = useState(false);
  const [filterCountryData, setFilterCountryData] = useState("1");
  const [Statedata, setStatedata] = useState([]);
  const [selectionCountry, setSelectionCountry] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  const [colors, setColors] = useState({});

  function generateColors(data) {
    const colorMapping = {};
    data.forEach((item) => {
      const randomColor =
        "#" +
        Math.floor(Math.random() * 16777215)
          .toString(16)
          .padStart(6, "0");
      colorMapping[item.countryname] = randomColor;
    });
    return colorMapping;
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const fetchCountryData = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    let cdate = formatDate(new Date());
    let startdate = selectionCountry.startDate
      ? formatDate(selectionCountry.startDate)
      : "";
    let enddate = selectionCountry.endDate
      ? formatDate(selectionCountry.endDate)
      : "";

      if (startdate === cdate && enddate === cdate) {
        setDateRangeStage("Select Date Range");
        startdate = "";
        enddate = "";
      } else {
        setDateRangeStage(startdate + " - " + enddate);
      }

      toggleLeadStagePicker();
    if (isLeadStagePickerOpen) {
      setIsLeadStagePickerOpen(!isLeadStagePickerOpen);
    } else {
      setIsLeadStagePickerOpen(isLeadStagePickerOpen);
    }

    const response = await axios.get(
      `${baseAPI}userget/getdashboarddetailCountry?option=${filterCountryData}&startDate=${startdate}&endDate=${enddate}`,
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      }
    );

    if (response && response.data && response.data.data) {
      setCountrydata(response.data.data.byCountry);
      setColors(generateColors(response.data.data.byCountry));
    }
  };

  useEffect(() => {
    const fetchDefaultData = async () => {
      const storedToken = JSON.parse(localStorage.getItem("token"));

      const response = await axios.get(
        `${baseAPI}userget/getdashboarddetailCountry?option=1&startDate=&endDate=`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      if (response && response.data && response.data.data) {
        setCountrydata(response.data.data.byCountry);
        setColors(generateColors(response.data.data.byCountry));
        setStatedata(response.data.data.byCity);
        setSelectionCountry({
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        });
      }
    };

    fetchDefaultData();
  }, []);

  const handleFilterCountryChange = (event) => {
    setFilterCountryData(event.target.value);
  };

  const handleSelectCountry = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectionCountry({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  const darkenColor = (color, amount) => {
    const usePound = color[0] === "#";
    const num = parseInt(usePound ? color.slice(1) : color, 16);
    let r = (num >> 16) - amount;
    let g = ((num >> 8) & 0x00ff) - amount;
    let b = (num & 0x0000ff) - amount;

    r = r < 0 ? 0 : r;
    g = g < 0 ? 0 : g;
    b = b < 0 ? 0 : b;

    return (
      (usePound ? "#" : "") +
      ((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")
    );
  };

  const toggleLeadStagePicker = () => {
    setIsLeadStagePickerOpen(!isLeadStagePickerOpen);    
  };

  return (
    <>
     <div
      style={{
        width: "50%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        marginRight: "1px",
        borderTopLeftRadius: "17px",
        borderBottomLeftRadius: "17px",
      }}
    >
      <div
        className="outerFilterLeadStage"
        style={{ gap: "1rem", display: "flex", justifyContent: "flex-start" }}
      >
        <div
          className="innerFilterLead"
          style={{ gap: "20px", marginLeft: "2rem", marginTop: "1rem" }}
        >
          <div className="filter-icon-stage">
            <img src={require("../../../Icons/filterIcon.png")} alt="filter" />
            FILTER
          </div>

          <button
            style={{
              marginBottom: "7px",
              width: "10rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "11px",
            }}
            onClick={toggleLeadStagePicker}
          >
            <b>{dateRangeStage}</b>
          </button>

          {isLeadStagePickerOpen && (
            <div
              style={{
                position: "absolute",
                zIndex: 999,
                border: "solid 1px black",
                marginLeft: "-2pc",
                width: "35pc",
                background: "white",
                marginTop: "1rem",
              }}
            >
              <DateRangePicker
                ranges={[selectionCountry]}
                onChange={handleSelectCountry}
              />
              <button
                style={{
                  marginBottom: "7px",
                  width: "8rem",
                  height: "2.5rem",
                  borderRadius: "0.5rem",
                  fontSize: "13px",
                  backgroundColor: "#5B489D",
                  color: "White",
                  border: "none",
                  position: "relative",
                  top: "1px",
                  left: "16pc",
                }}
                onClick={fetchCountryData}
              >
                Apply Filter
              </button>
              <button
                style={{
                  marginBottom: "1rem",
                  width: "7.5rem",
                  height: "2.5rem",
                  borderRadius: "0.5rem",
                  fontSize: "13px",
                  color: "red",
                  backgroundColor: "white",
                  border: "none",
                  fontWeight: "bold",
                  position: "relative",
                  top: "1px",
                  left: "17pc",
                }}
                onClick={() => setIsLeadStagePickerOpen(false)}
              >
                Close
              </button>
            </div>
          )}

          <select
            value={filterCountryData}
            onChange={handleFilterCountryChange}
            style={{
              marginBottom: "7px",
              width: "6rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              fontWeight: "bold",
            }}
          >
            <option value="1">Export</option>
            <option value="2">Import</option>
          </select>
          <button
            style={{
              marginBottom: "7px",
              width: "8rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              backgroundColor: "#5B489D",
              color: "White",
              border: "none",
              marginLeft: "10px",
            }}
            onClick={fetchCountryData}
          >
            Apply
          </button>
        </div>
      </div>

      <hr />
      <div
        style={{
          padding: "20px",
          backgroundColor: "white",
          borderRadius: "8px",
          textAlign: "left",
        }}
      >
        <h3
          style={{
            color: "#6A6A6A",
            fontSize: "22px",
            fontWeight: "800",
            marginBottom: "10px",
          }}
        >
          World Execution Percentage
        </h3>
        <div style={{ marginBottom: "20px" }}>
          {countrydata.length > 0 ? (
            countrydata.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "10px 0",
                  position: "relative",
                  height: "50px",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "150px",
                    fontWeight: "bold",
                  }}
                >
                  {item.countryname}
                </span>

                <div
                  style={{
                    display: "inline-block",
                    height: "60%",
                    borderRadius: "20px",
                    position: "relative",
                    flexGrow: 1,
                    marginLeft: "10px",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    minHeight: "40px", // Ensuring a minimum height
                  }}
                >
                  <div
                    style={{
                      backgroundColor: colors[item.countryname],
                      width: `${item.execution_percentage_overall}%`,
                      minWidth: "100px", // Ensuring the bar is at least 100px wide
                      color: "white",
                      height: "100%",
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      paddingRight: "5px",
                      fontWeight: "600",
                      position: "relative", // Important to control the circle position
                    }}
                  >
                    <span style={{ paddingLeft: "10px", fontSize: "12px" }}>
                      {item.execution_percentage_overall}%
                    </span>
                    <div
                      style={{
                        backgroundColor: darkenColor(
                          colors[item.countryname],
                          40
                        ),
                        // border: `0.5px solid grey`,
                        boxShadow: "4px 4px 4px rgba(0, 0, 0, 0.1)",
                        borderRadius: "50%",
                        width: "38px",
                        height: "38px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: darkenColor(colors[item.countryname], 40),
                        fontSize: "12px",
                        fontWeight: "bold",
                        marginLeft: "10px",
                        position: "absolute", // Absolute position within the bar
                        right: "0px", // Adjust this value to fine-tune the circle's alignment
                        top: "50%",
                        transform: "translateY(-50%)", // Ensures the circle is vertically centered
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div>No data available</div>
          )}
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center",
                  backgroundColor: "#f4f4f4",
                  fontWeight: "bold",
                }}
              >
                Country
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center",
                  backgroundColor: "#f4f4f4",
                  fontWeight: "bold",
                }}
              >
                Booking
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center",
                  backgroundColor: "#f4f4f4",
                  fontWeight: "bold",
                }}
              >
                Execution
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center",
                  backgroundColor: "#f4f4f4",
                  fontWeight: "bold",
                }}
              >
                Cancelled
              </th>
            </tr>
          </thead>
          <tbody>
            {countrydata.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {item.countryname}
                </td>
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {item.totalbooking}
                </td>
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {item.execution}
                </td>
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {item.cancelled}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

     <style jsx>{`
      .filter-icon-stage {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.25);
    width: 87px;
    height: 104%;
    position: relative;
    padding: 9px;
    padding-top: 16px;
    background-color: white;
    border-radius: 9px;
    top: -3px;
    left: -29px;
    font-size: 12px;
}
      `}</style>
    </>
   
  );
};

export default Countrygraph;
